import { Button } from "antd";
import React from "react";

interface Props {
  tabTotals: { all: number, error: number },
  filter: string,
  handlerChange: any,
}

const TabsFilters = ({ tabTotals, filter, handlerChange }: Props) => {

  const TabsFilters = [
    { id: 1, name: "All", key: "all", amount: tabTotals.all || 0 },
    { id: 2, name: "Needs Attention", key: "error", amount: tabTotals.error || 0 },
  ];

  return (
    <section className="ButtonTabsFilters">
      {TabsFilters?.map((tab) => (
        <Button
          onClick={() => handlerChange(tab.key)}
          className={`tab ${filter === tab.key && "tab-active"} ${tab.amount === 0 && "disabled"}`}
          key={tab.key}
          disabled={tab.amount === 0}>
          {tab.name} <span className="number">{tab.amount}</span>
        </Button>
      ))}
    </section>
  );
};
export default TabsFilters;
